import React, { useState } from "react";
import useAuthEffect from "../../hook/useAuthEffect";
import axios from "axios";
import { useEffect } from "react";

const LanguageSelect = (props) => {
  const [languages, setLanguages] = useState([]);
  const [languagesPrioritized, setLanguagesPrioritized] = useState([]);

  useAuthEffect(() => {
    axios.get(`${window.API_URL}/language/get.php`).then((result) => {
      setLanguages(result.data.data);
    });
  });

  useEffect(() => {
    const nonPriority = [];
    const priority = [];

    languages.forEach((lang) => {
      if (props.prioritize && props.prioritize.includes(lang.code)) {
        priority.push(lang);
      } else {
        nonPriority.push(lang);
      }
    });
    if (priority.length)
      priority.push({ name: "--------", code: "", disabled: true });
    setLanguagesPrioritized(priority.concat(nonPriority));
  }, [props.prioritize, languages]);

  return (
    <select
      value={props.value}
      name={props.name}
      className={"select select--primary " + props.className}
      onChange={props.onChange}
      disabled={props.disabled}
    >
      <option selected disabled></option>
      {languagesPrioritized.map((language) => (
        <option
          disabled={language.disabled}
          selected={props.selected == language.code}
          value={language.code}
          data-code-iso={language.codeIso}
        >
          {language.name}
        </option>
      ))}
    </select>
  );
};

export default LanguageSelect;
